module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-2500.e236bb30.svg";